import React from "react";
import { Link } from "react-router-dom";
import "./FrontPage.css";

const FrontPage = () => {
  const cards = [
    {
      title: "Blood Portal",
      path: "/home",
      desc: "Access blood donation drives, donor lists, and live requests in one place.",
    },
    {
      title: "About",
      path: "/about",
      desc: "Learn about our mission, vision, and the impact of our organization.",
    },
    {
      title: "View Cases",
      path: "/tabs",
      desc: "Explore current support cases and see where your help makes a difference.",
    },
    {
      title: "Become a Member",
      path: "/membership",
      desc: "Join our network and contribute towards saving lives through our initiatives.",
    },
    {
      title: "Our Legal Identity",
      path: "/legal",
      desc: "View official registrations and legal documents that establish our trust.",
    },
    // {
    //   title: "Admin Only",
    //   path: "/admin/login",
    //   desc: "Only Admin can access this portal.",
    // },
  ];

  return (
    <div className="frontpage-container">
      {/* Logo Section */}
      <div className="logo-container">
        <img
          src="assets/bloodlogo-removebg-preview.png"
          alt="Organization Logo"
          className="frontpage-logo"
        />
      </div>

      {/* Header Section */}
      <div className="frontpage-header">
        <h1>Welcome to Sarv Sahayata Sangathan</h1>
        <p>"Together we care, together we save lives."</p>
      </div>

      {/* Cards Section */}
      <div className="card-grid">
        {cards.map((card, index) => (
          <Link key={index} to={card.path} className="card">
            <h2>{card.title}</h2>
            <div className="card-line"></div>
            <p>{card.desc}</p>
          </Link>
        ))}
      </div>

      {/* Footer */}
      <div className="frontpage-footer">
        © {new Date().getFullYear()} Sarv Sahayata Sangathan. All rights reserved.
      </div>
    </div>
  );
};

export default FrontPage;
